module.exports = "描述一下你期望这个新功能的 API 是如何使用的，并提供一些代码示例。请用 [Markdown](https://guides.github.com/features/mastering-markdown/) 格式化你的代码片段。\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh/proposalHelp.md
// module id = 502
// module chunks = 0